import { render, staticRenderFns } from "./ShowsIndex.vue?vue&type=template&id=3fc8440c&"
import script from "./ShowsIndex.vue?vue&type=script&lang=js&"
export * from "./ShowsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports